import _ from 'lodash';
import provincesData from '../json/provinces.json';
import wardsData from '../json/wards.json';

jQuery(function ($) {
    const $root = $('#contact-form');
    if (!$root.length) {
        return;
    }

    const citySelect = $root.find('.contact-province-field');
    const wardSelect = $root.find('.contact-ward-field');
    if (!citySelect.length || !wardSelect.length) {
        return;
    }

    const availableCitiesRaw = $root.find('input[name="available_cities"]').val();
    const availableWardsRaw = $root.find('input[name="available_wards"]').val();

    const provinces = Object.values(provincesData).sort((a, b) =>
        a.name.localeCompare(b.name, 'vi')
    );

    const provinceByName = {};
    _.each(provinces, (p) => {
        provinceByName[p.name] = p;
    });

    const wardsByParent = _.groupBy(Object.values(wardsData), 'parent_code');

    let provinceOptions = _.map(provinces, (p) => p.name);

    function resolveProvinceName(raw) {
        const s = String(raw || '').trim();
        if (!s) {
            return '';
        }
        if (provinceByName[s]) {
            return s;
        }
        const stripped = s.replace(/^(Tỉnh|Thành phố)\s+/u, '').trim();
        if (provinceByName[stripped]) {
            return stripped;
        }
        const byWithType = _.find(provinces, (p) => (p.name_with_type || '') === s);
        return byWithType ? byWithType.name : '';
    }

    function resolveWardName(raw, provinceName) {
        const s = String(raw || '').trim();
        if (!s) {
            return '';
        }
        const p = provinceByName[provinceName];
        if (!p) {
            return s;
        }
        const list = wardsByParent[p.code] || [];
        if (_.some(list, (w) => w.name === s)) {
            return s;
        }
        const byWithType = _.find(list, (w) => (w.name_with_type || '') === s);
        return byWithType ? byWithType.name : s;
    }

    if (availableCitiesRaw) {
        try {
            const ac = JSON.parse(availableCitiesRaw);
            if (_.isArray(ac) && ac.length) {
                provinceOptions = _.filter(provinceOptions, (name) => {
                    const p = provinceByName[name];
                    if (!p) {
                        return false;
                    }
                    return _.some(ac, (apiCity) => {
                        const t = String(apiCity).trim();
                        const shortName = t.replace(/^(Tỉnh|Thành phố)\s+/u, '').trim();
                        return (
                            t === p.name ||
                            shortName === p.name ||
                            t.includes(p.name) ||
                            p.name.includes(t)
                        );
                    });
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    const priorityProvinceNames = ['Hà Nội', 'Hồ Chí Minh'];
    const pinnedProvinces = _.filter(priorityProvinceNames, (n) => _.includes(provinceOptions, n));
    if (pinnedProvinces.length) {
        const restProvinces = _.filter(provinceOptions, (n) => !_.includes(pinnedProvinces, n));
        provinceOptions = pinnedProvinces.concat(restProvinces);
    }

    if (citySelect.data('all')) {
        provinceOptions.unshift('Tất cả Tỉnh/Tp');
    }

    const provincePlaceholder = citySelect.data('placeholder') || '';
    const wardPlaceholder = wardSelect.data('placeholder') || '';

    let initDone = false;

    const initialProvinceRaw = String(citySelect.data('selectedCity') || '').trim();
    const initialProvinceName = resolveProvinceName(initialProvinceRaw);
    const initialWardRaw = String(wardSelect.data('selectedWard') || '').trim();

    function isAllProvinceName(name) {
        return !name || name === 'Tất cả Tỉnh/Tp';
    }

    function destroyWardSelect2() {
        if (wardSelect.hasClass('select2-hidden-accessible')) {
            wardSelect.select2('destroy');
        }
    }

    function fillWardOptions(provinceDisplay) {
        destroyWardSelect2();

        let wardTexts = [];
        const isAllProvince =
            !provinceDisplay ||
            provinceDisplay === 'Tất cả Tỉnh/Tp' ||
            !provinceByName[provinceDisplay];

        if (isAllProvince) {
            wardSelect.prop('disabled', true);
            wardTexts = [''];
        } else {
            wardSelect.prop('disabled', false);
            const code = provinceByName[provinceDisplay].code;
            const list = (wardsByParent[code] || []).slice().sort((a, b) =>
                a.name.localeCompare(b.name, 'vi')
            );
            wardTexts = _.map(list, (w) => w.name);

            if (availableWardsRaw) {
                try {
                    const aw = JSON.parse(availableWardsRaw);
                    if (_.isArray(aw) && aw.length) {
                        wardTexts = _.filter(wardTexts, (w) =>
                            _.some(aw, (a) => {
                                const s = String(a).trim();
                                return s === w || w.includes(s) || s.includes(w);
                            })
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            const initialWardName = resolveWardName(initialWardRaw, provinceDisplay);
            if (
                initialWardName &&
                provinceDisplay === initialProvinceName &&
                !_.includes(wardTexts, initialWardName)
            ) {
                wardTexts.push(initialWardName);
                wardTexts.sort((a, b) => String(a).localeCompare(String(b), 'vi'));
            }

            if (wardSelect.data('all')) {
                wardTexts.unshift('Tất cả Phường/Xã');
            } else {
                wardTexts.unshift('');
            }
        }

        wardSelect.empty();
        wardSelect.select2({
            data: wardTexts,
            placeholder: wardPlaceholder,
            theme: 'default form-control',
            width: '100%',
        });

        wardSelect.off('change.contactWard').on('change.contactWard', function () {
            if (initDone && typeof window.getContent === 'function') {
                window.getContent('idWriteContent', 'idWriteSidebar');
            }
        });
    }

    citySelect.select2({
        data: provinceOptions,
        placeholder: provincePlaceholder,
        theme: 'default form-control',
        width: '100%',
    });

    citySelect.off('change.contactCity').on('change.contactCity', function () {
        const v = $(this).val();
        fillWardOptions(v);
        if (initDone && typeof window.getContent === 'function') {
            window.getContent('idWriteContent', 'idWriteSidebar');
        }
    });

    const initialCity =
        initialProvinceName && _.includes(provinceOptions, initialProvinceName)
            ? initialProvinceName
            : citySelect.val() || '';

    citySelect.val(initialCity || null);
    fillWardOptions(initialCity);

    if (initialWardRaw && !isAllProvinceName(initialCity)) {
        const wn = resolveWardName(initialWardRaw, initialCity);
        if (wn) {
            wardSelect.val(wn);
        }
    }

    initDone = true;
});
